import UImage from '../../../../components/UImage';

import { useDiaryShortsContext } from './_DiaryShortsRoot';

const _DiaryShortsPhotoIndicator = () => {
  const {
    diary: { id, photos },
    getDiaryPhotoId,
    diaryPhotoIndexMap,
  } = useDiaryShortsContext();

  const handlescrollIntoView = (index: number) => {
    const diaryPhotoElementId = getDiaryPhotoId(id, index);

    const section = document.getElementById(diaryPhotoElementId);

    section?.scrollIntoView({ behavior: 'smooth' });
  };

  const currentIndex = diaryPhotoIndexMap.get(id) ?? 0;

  return (
    <div className="fixed top-1/2 right-16px z-10 -translate-y-1/2 space-y-8px">
      {photos.map((photo, index) => (
        <button
          key={photo}
          onClick={() => handlescrollIntoView(index)}
          className={`relative block h-46px w-46px overflow-hidden rounded-[10px] ${
            currentIndex === index ? 'ring-2 ring-brand-1' : ''
          }`}
          type="button"
        >
          <UImage
            src={photo}
            width={46}
            height={46}
            className="h-46px w-46px object-cover object-center"
          />
        </button>
      ))}
    </div>
  );
};

export default _DiaryShortsPhotoIndicator;
